import React from 'react';

import { Inline, Stack } from '@atlaskit/primitives/compiled';
import HeadingSkeleton from '@atlaskit/skeleton';

import { CardList } from '../../../common/ui/CardList/CardList';
import { AgentCardSkeleton } from '../../agent-card/components/AgentCardSkeleton';
import { RecommendedPanel } from '../../recommended-list/components/RecommendedPanel';

const RECOMMENDED_CARD_COUNT = 4;
const RECOMMENDED_COLUMNS = 2;

const skeletonRecommendedKeys = Array.from(
	{ length: RECOMMENDED_CARD_COUNT },
	(_, index) => `recommended-skeleton-card-${index}`,
);

export const RecommendedSkeleton = ({ testId }: { testId?: string }): React.JSX.Element => (
	<Stack space="space.200">
		<Inline alignBlock="center">
			<HeadingSkeleton width={80} height={20} isShimmering />
		</Inline>
		<RecommendedPanel testId={testId ? `${testId}--recommended` : undefined}>
			<CardList
				columns={RECOMMENDED_COLUMNS}
				testId={testId ? `${testId}--recommended-items` : undefined}
			>
				{skeletonRecommendedKeys.map((key, index) => (
					<AgentCardSkeleton
						key={key}
						testId={testId ? `${testId}--recommended-card-${index}` : undefined}
					/>
				))}
			</CardList>
		</RecommendedPanel>
	</Stack>
);
